import {ajax} from 'rxjs/ajax';

export class BaseApi {
  public buildApiUrl(path: string) {
    return path;
  }

  public getJSON(path: string) {
    return ajax.getJSON(this.buildApiUrl(path), this.getHeaders());
  }

  public getApiToken() {
    return null;
  }

  public getHeaders() {
    const token = this.getApiToken();
    return token ? {Token: token} : {};
  }
}
